/**
 * @file 主题切换弹窗
 * @description 顶栏入口；弹窗内嵌 ThemeSwitcher，选择即切换并持久化。
 *
 * @whenToUse 后台顶栏「修改主题」入口。
 * @whenNotToUse Showcase 页内直接铺开 ThemeSwitcher；程序内静默切主题。
 */

import { useState } from 'react'
import { Palette } from 'lucide-react'
import { Dialog } from '@/components/ui/dialog.tsx'
import { IconButton } from '@/components/ui/icon-button.tsx'
import { ThemeSwitcher } from '@/components/ui/theme-switcher.tsx'

/**
 * 主题切换：IconButton 触发 Dialog，内容为 ThemeSwitcher。
 */
export function ThemeSwitcherDialog() {
  const [open, setOpen] = useState(false)

  return (
    <>
      <IconButton
        variant="ghost"
        aria-label="修改主题"
        icon={<Palette className="size-4" aria-hidden />}
        onClick={() => setOpen(true)}
      />
      <Dialog
        open={open}
        onOpenChange={setOpen}
        title="切换主题"
        className="max-w-5xl"
      >
        <ThemeSwitcher />
      </Dialog>
    </>
  )
}
